import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import {
  COMMUNITY_SIDEBAR_BADGE_RIGHT_WITH_PLUS,
  COMMUNITY_SIDEBAR_INDICATOR_LEFT,
  COMMUNITY_SIDEBAR_MENU_ITEM_PADDING,
  SIDEBAR_MENU_ITEM_PADDING_X,
  SIDEBAR_MENU_ROW_GAP,
  SIDEBAR_SPACE_12,
  sidebarMenuListItemHighlight,
} from 'styles/sidebarMenuListItemHighlight';

export const StyledMenuItemBlock = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  gap: ${SIDEBAR_MENU_ROW_GAP};
  letter-spacing: 1px;
  padding: ${COMMUNITY_SIDEBAR_MENU_ITEM_PADDING};
  border-radius: 6px;
`;
export const StyledMenuItemLinkBlock = styled(NavLink)`
  flex-grow: 1;
  display: flex;
  text-decoration: none;
  align-items: center;
  gap: ${SIDEBAR_MENU_ROW_GAP};
  letter-spacing: 1px;
  padding: ${COMMUNITY_SIDEBAR_MENU_ITEM_PADDING};
  border-radius: 6px;
  ${({ menuBlockStyles }) => menuBlockStyles}
  ${sidebarMenuListItemHighlight({
    indicatorLeft: COMMUNITY_SIDEBAR_INDICATOR_LEFT,
  })}

  &.active,
  &:hover {
    & > span {
      color: ${({ theme }) => theme.color.brightTurquoise};
    }
    & > div {
      & > svg {
        fill: ${({ theme }) => theme.color.brightTurquoise};
        path {
          fill: ${({ theme }) => theme.color.brightTurquoise};
          stroke: ${({ theme }) => theme.color.brightTurquoise};
        }
        circle {
          stroke: ${({ theme }) => theme.color.brightTurquoise};
        }
      }
    }
  }
`;

export const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${SIDEBAR_SPACE_12};
  height: ${SIDEBAR_SPACE_12};

  svg {
    width: ${SIDEBAR_SPACE_12};
    height: ${SIDEBAR_SPACE_12};
    ${({ iconStyles }) => iconStyles};
  }
`;

export const StyledRightIcon = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    prop !== '$withPlusButton' && prop !== 'rightIconRight',
})`
  position: absolute;
  right: ${({ rightIconRight, $withPlusButton }) =>
    rightIconRight ||
    ($withPlusButton
      ? COMMUNITY_SIDEBAR_BADGE_RIGHT_WITH_PLUS
      : SIDEBAR_MENU_ITEM_PADDING_X)};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 900000;
  > div {
    width: 31px;
    height: 31px;
    transition: all 0.2s linear;
    :hover {
      scale: 1.2;
    }
  }
`;

export const CountWrapper = styled.span`
  position: relative;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.color.white} !important;
`;

export const StyledTitle = styled.span`
  font-size: 13px;
  text-transform: uppercase;
  line-height: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.baliHai};
  text-align: left;
  text-decoration: none;
  letter-spacing: 1px;
  display: inline-block;
  position: relative;
`;
